import React from "react";
import ToolTip from "../../HOC/ToolTip";

class Switch extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false,
			value: 0,
		};
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange() {
		if (this.state.checked) {
			this.setState({ checked: false, value: 0 });
		} else {
			this.setState({ checked: true, value: 1 });
		}
	}

	componentDidMount() {
		this.setState({ checked: this.props.checked, value: this.props.value });
	}

	componentDidUpdate(prevProps) {
		if (prevProps.checked !== this.props.checked) {
			this.setState({
				checked: this.props.checked,
				value: this.props.value,
			});
		}
	}

	render() {
		return (
			<div
				className={`form-switch flex align-center flex-between ${
					this.props.size && this.props.size === "small"
						? "form-switch-small"
						: ""
				}`}
				style={{
					backgroundColor: this.props.bgColor,
					borderBottom: this.props.borderBottom ? "1px solid #f1f1f1" : "",
					padding: this.props.padding
						? this.props.padding
						: this.props.bgColor
						? "15px 10px"
						: "10px 0px",
					margin: this.props.margin ? this.props.margin : "",
				}}
			>
				<div
					style={{
						fontWeight: 500,
						width:
							!this.props.noTrunc && !this.props.tooltipText
								? "calc(100% - 150px)"
								: this.props.tooltipText && this.props.size !== "small"
								? "calc(100% - 70px)"
								: "calc(100% - 50px)",
					}}
				>
					{this.props.title ||
						(this.props.label && (
							<div
								style={{
									fontWeight: this.props.light ? 400 : 500,
									maxWidth:
										!this.props.noTrunc && !this.props.tooltipText
											? "100%"
											: "",
									textOverflow: !this.props.noTrunc ? "ellipsis" : "",
									overflow:
										!this.props.noTrunc && !this.props.tooltipText
											? "hidden"
											: "",
									whiteSpace:
										!this.props.noTrunc && !this.props.tooltipText
											? "nowrap"
											: "",
								}}
							>
								{this.props.title || this.props.label}
								{this.props.tooltipText && (
									<ToolTip
										adjustParentStyle={true}
										width={this.props.tooltipWidth || 170}
									>
										{this.props.tooltipText}
									</ToolTip>
								)}
							</div>
						))}
				</div>
				<div
					className={`form-switch-container`}
					style={{
						marginLeft: this.props.title ? "15px" : "",
						order: this.props.position === "left" ? "-1" : "",
					}}
				>
					<div className="form-check form-check-inline flex align-center">
						{this.props.checked && this.props.disabledText && (
							<span
								className="small"
								style={{
									marginRight: "5px",
									fontWeight: "500",
									color: "#ff0505",
								}}
							>
								{this.props.disabledText}
							</span>
						)}
						<label className="bo-switch">
							<input
								type="checkbox"
								className="checkbox__input"
								value={this.props.value}
								checked={this.props.checked}
								onChange={this.props.switchChange || this.props.onChange}
								disabled={this.props.disabled}
							/>
							<span className="bo-switch-track" />
						</label>
						{!this.props.checked && this.props.enabledText && (
							<span
								className="small"
								style={{
									marginLeft: "5px",
									fontWeight: "500",
									color: "#0dd471",
								}}
							>
								{this.props.enabledText}
							</span>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Switch;
